import { TipoPessoa } from "../TipoPessoa";
import { EnumValue } from "./enum-value";

export const TipoPessoaEnum = {
    fisica: 'FISICA',
    juridica: 'JURIDICA'
}

export const TipoPessoaValues: EnumValue[] = [
    {
        codigo: TipoPessoaEnum.fisica,
        descricao: 'PESSOA FÍSICA'
    },
    {
        codigo: TipoPessoaEnum.juridica,
        descricao: 'PESSOA JURÍDICA'
    }
]

export const getTipoPessoaLabel = (tipo: TipoPessoa): string => {
    const match = TipoPessoaValues.find(
      value => value.codigo === tipo
    );
    return match ? match.descricao : '';
  };

export const getOptionsTipoPessoa = [
    {
      key: TipoPessoaEnum.fisica,
      value: TipoPessoaEnum.fisica,
      label: 'Física'
    },
    {
      key: TipoPessoaEnum.juridica,
      value: TipoPessoaEnum.juridica,
      label: 'Jurídica'
    }
  ];